module.exports = __webpack_public_path__ + "static/media/alUSD3CRV-logo.6efff26a.png";